import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Antequera"
      slug="antequera"
      cp="29200"
      poblacion={41000}
      zonaGeo="Antequera y Norte"
      lat={37.0181}
      lng={-4.5594}
      zonas={["Centro Antequera", "El Romeral", "Bobadilla", "La Estación"]}
      landmarks={["Alcazaba", "Dólmenes UNESCO", "El Torcal"]}
      municipiosLimitrofes={["Mollina", "Archidona", "Casabermeja", "Campillos"]}
      festivalLocal="Real Feria de Agosto"
      contextoTipologico="Ciudad interior con clima continental, mosquito común y mosca de campo abundantes en verano, casas históricas con ventanas antiguas que requieren mosquiteras fijas a medida."
      isCoreZone={false}
    />
  );
}